<div class="dialog-content-wrapper" style="display: contents">
  <mat-toolbar mat-dialog-title class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{dialogTitle}}</span>
      <button (click)="dialogRef.close(false)" aria-label="Close dialog">
        <mat-icon class="closebtn">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <nav mat-tab-nav-bar>
    <a mat-tab-link (click)="selectedTab = 'alertInfo'" [active]="selectedTab == 'alertInfo'">Details </a>
    <a mat-tab-link (click)="selectedTab = 'documents'" [active]="selectedTab == 'documents'">Documents </a>
  </nav>
  <div class="container">

    <div class="tabviews">
      <div class="tab-content" [class.show]="selectedTab == 'alertInfo'">
        <!-- <h6 style="text-align: center;color: '#039be5'">
          <button mat-button color="accent" (click)="openCase()" style="margin-left: -16px;text-transform: uppercase;">
            {{getCaseNumber()}}
          </button>
        </h6> -->
        <!-- <hr> -->
        <table style="width: 90%;margin-left: 22px;">
          <tr>
            <td>Case Number</td>
            <td>: &nbsp; &nbsp;
              <a (click)="openCase()" style="cursor: pointer; color: #039be5">
                {{ getCaseNumber() }}
              </a>
            </td>
          </tr>
          <tr>
            <td>Sender</td>
            <td>: &nbsp; &nbsp; {{ userName }}</td>
          </tr>
          <tr>
            <td>Creation Date</td>
            <td>: &nbsp; &nbsp; {{ formatTime(alert.created_date) }}</td>
          </tr>
          <tr>
            <td>Description :</td>
            <td>: &nbsp; &nbsp; {{ alert.message }}</td>
          </tr>
          <tr>
            <td>Guardian Name</td>
            <td>: &nbsp; &nbsp; {{ guardianName }}</td>
          </tr>
          <tr>
            <td>Ward Name</td>
            <td>: &nbsp; &nbsp; {{ wardName }}</td>
          </tr>
          <tr>
            <td>Case Last Modified</td>
            <td>: &nbsp; &nbsp; {{ caseLastModified }}</td>
          </tr>

        </table>
        <!-- <h6><b>Sender:</b> &nbsp; &nbsp; {{ userName }}</h6>
        <h6><b>Sent:</b> &nbsp; &nbsp; {{ formatTime(alert.created_date) }}</h6>
        <h6><b>Alert Description:</b> &nbsp; &nbsp; {{ alert.message }}</h6>
        <h6><b>Guardian Name:</b> &nbsp; &nbsp; {{ guardianName }}</h6>
        <h6><b>Ward Name:</b> &nbsp; &nbsp; {{ wardName }}</h6>
        <h6><b>Case Last Modified:</b> &nbsp; &nbsp; {{ caseLastModified }}</h6> -->

        <br>
        <div class=" commentSection" style="margin-top: 50px;">
          <comments [orgId]="orgId" [caseId]="alertId" [mode]="'ALERT'"></comments>
        </div>

      </div>
      <div class="tab-content" [class.show]="selectedTab == 'documents'">
        <ng-container *ngIf="isFileLoading;else file_content">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-container>

        <ng-template #file_content>
          <!-- <mat-table [dataSource]="files" class="mat-elevation-z8" *ngIf="files.length > 0" style="margin-left: 10px;"> -->
          <mat-table [dataSource]="files" class="mat-elevation-z8" style="margin-left: 10px;">
            <ng-container matColumnDef="file">
              <mat-header-cell *matHeaderCellDef> File. </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.file_name}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="fileSize">
              <mat-header-cell *matHeaderCellDef> Size </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ cleanFileSize(element.size) }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Link">
              <mat-header-cell *matHeaderCellDef>
                <span>Action</span>
                <input hidden type="file" #docUpload (change)="upload($event)" />
                <button mat-icon-button style="margin-left: 50px;" (click)="docUpload.click()" color="accent"
                  class="maxWidth">
                  <i class="material-icons" style="color:#039be5">attach_file</i>
                </button>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a [href]="element.url" target="_blank" mat-icon-button color="accent">
                  <i class="material-icons">get_app</i>
                </a>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>

          <br>
        </ng-template>
      </div>
    </div>
    <!-- <hr> -->
    
  </div>

  <div class="actionResolveButton">
    <button mat-raised-button (click)="closeAlert()" color="accent" class="maxWidth" style="text-transform: uppercase;">
      Resolve
    </button>
  </div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/alertList/openAlert/openAlert.component.html